var _rect, _path, _circle, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: "5O",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#21E190"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7C15.4869 7 13.9934 7.34339 12.6323 8.00429C11.2711 8.66519 10.0776 9.62638 9.14181 10.8154C8.20599 12.0045 7.55222 13.3904 7.22974 14.8688C6.90726 16.3472 6.92448 17.8795 7.2801 19.3502C7.63573 20.821 8.32049 22.1919 9.28279 23.3596C10.2451 24.5273 11.4598 25.4615 12.8355 26.0916C14.2112 26.7217 15.712 27.0315 17.2247 26.9975C18.7375 26.9635 20.2228 26.5866 21.5688 25.8953L17 17V7Z",
    fill: "#EBEBEB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 9.25,
    stroke: "#EBEBEB",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 10.9824,
    width: 2.86396,
    height: 2,
    transform: "rotate(-43.8096 23 10.9824)",
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.fa8989915f4521e21a696977ff73331d.svg";
export { ForwardRef as ReactComponent };